import useEffectOnce from 'src/utils/hooks/useEffectOnce';

export const useResetPageScrollOnMount = () => {
  useEffectOnce(() => {
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
  });
};
